import type { ComponentProps } from 'react'

import { cn } from '@morpho-org/ui-v6/utils'

/** Recap display mode — a review step (larger padding) vs the in-flight confirmation. */
export type RecapMode = 'Review' | 'Confirm'

export interface RecapContainerProps extends ComponentProps<'div'> {
  mode?: RecapMode
}

/**
 * Shared recap card wrapper. Tailwind replacement for the ui-v5 (legacy kit)
 * `styled(Stack)` `StyledContainer` from `Recap.styles.ts`.
 *
 * Padding mirrors the original: Review mode used `padding.m padding.s`
 * (32px vertical / 20px horizontal); other modes used `padding.s` (20px).
 */
export const RecapContainer = ({ mode, className, ...props }: RecapContainerProps) => (
  <div
    className={cn(
      'flex',
      cn('rounded-lg bg-muted', mode === 'Review' ? 'px-md py-lg' : 'p-md', className)
    )}
    {...props}
  />
)
